import React from 'react';
import { Hero } from './sections/Hero';
import { Benefits } from './sections/Benefits';
import { CaseStudy } from './sections/CaseStudy';
import { Comparison } from './sections/Comparison';
import { CallToAction } from './sections/CallToAction';
export const NightPhaseLanding = () => {
  return <div className="bg-slate-50 text-slate-800 w-full min-h-screen" data-id="element-88">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-89">
        <Hero data-id="element-90" />
        <Benefits data-id="element-91" />
        <CaseStudy data-id="element-92" />
        <Comparison data-id="element-93" />
        <CallToAction data-id="element-94" />
      </div>
    </div>;
};